var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCollapeAll = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Collape All")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rec/Summary-View-Crumb",
    transform: "translate(-1121.000000, -12.000000)",
    fill: "#335498",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Summary-View-Crumb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1136.85971,16.2506522 C1134.51292,12.1858353 1129.31509,10.7930421 1125.25064,13.1402919 C1121.18587,15.4867838 1119.79304,20.6844664 1122.14026,24.7491209 C1124.48673,28.8139378 1129.6844,30.2069475 1133.7489,27.8599143 C1137.81373,25.5126104 1139.20721,20.3151984 1136.85971,16.2506522 Z M1132.89925,26.3874432 C1129.64792,28.2652863 1125.4894,27.1509868 1123.61212,23.8989709 C1121.73441,20.6476046 1122.84908,16.4890904 1126.10051,14.6121675 C1129.35206,12.7344327 1133.51036,13.8486239 1135.38775,17.1005315 C1137.26519,20.352385 1136.15085,24.5100332 1132.89925,26.3874432 Z M1132.55938,20.1545436 L1128.10927,17.5591124 C1127.70374,17.3223522 1127.37664,17.5116413 1127.37892,17.9807231 L1127.4017,23.1323961 C1127.40376,23.6013697 1127.73486,23.7922827 1128.14158,23.5573628 L1132.55765,21.0077248 C1132.96393,20.773238 1132.9648,20.3913038 1132.55938,20.1545436 Z",
    id: "Collape-All",
    transform: "translate(1129.500000, 20.500000) rotate(-90.000000) translate(-1129.500000, -20.500000) "
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCollapeAll, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Collape All.4b91acb4.svg";
export { ForwardRef as ReactComponent };